import { createSelector } from 'reselect'

import { selectGeneralReportSettings } from 'partner360/features/generalReports'
import { getRoots } from 'partner360/features/generalReports/helpers/getRoots'

export const selectGeneralReportsRoots = createSelector([selectGeneralReportSettings], getRoots)
